// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__HNP5x","bigColWidth":"Table_bigColWidth__1c7tG","biggerColWidth":"Table_biggerColWidth__3maUC","row":"Table_row__P3hnn","col":"Table_col__3n8l6"};